module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/label_question.2a746.png";